// @flow

import React from "react";
import ReactDOM from "react-dom";

import Datepicker from "../components/Datepicker";

const els = document.querySelectorAll(".datepicker");
els.forEach((el: HTMLElement) => {
    const id = el.getAttribute("data-id");
    const disablePast = (el.getAttribute("data-disable-past") || "") === "true";
    if (id) {
        ReactDOM.render(
            <Datepicker
                disablePastDays={disablePast}
                datepickerId={id}
                debug={false}
            />,
            el
        );
    }
});
